export default "__VITE_ASSET__BZPNrqg8__"